import { config } from 'src/config';

const isDevelopment = () =>
  !config.NODE_ENV || ['development', 'local'].includes(config.NODE_ENV);

const isTest = () => config.NODE_ENV === 'test';

const isProduction = () => config.NODE_ENV === 'production';

const isServer = () => typeof window === 'undefined';

const isBrowser = () => !isServer();

const isMobileApp = () => !isServer() && window.HOVERApp !== undefined;

const hasWebViewChannels = () =>
  isMobileApp() && window.HOVERApp?.channels !== undefined;

const hasNativeShare = () => !!navigator && !!navigator.share;

export {
  isBrowser,
  isDevelopment,
  isTest,
  isProduction,
  isServer,
  isMobileApp,
  hasWebViewChannels,
  hasNativeShare,
};
